import React from 'react';
import Tooltip from 'mrf/view/Tooltip';

export default function TextIcon({ icon: Icon, color, tooltip, size=5 }) {
    return (
        <Tooltip content={tooltip} >
            <Icon className={`text-base w-${size} h-${size} fill-current text-${color}`} />
        </Tooltip>
    );
};
